import React, {useEffect, useMemo} from 'react';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {ViewMode} from '@taopix/taopix-core';
import {GridView, ListView, PrintPreviewView, SingleView} from './Pages';
import {ProductLayout} from '@taopix/taopix-core/dist/types/types';
import RetroGridView from './Pages/RetroGridView';
import RetroListView from './Pages/RetroListView';
import useViewMode from '../../Hooks/useViewMode';
import {useTaopix} from '../Context/TaopixContext';

export type PageViewProps = {
  layout: ProductLayout;
  containerRef: React.RefObject<HTMLElement>;
};

const PageViewFactory = (props: PageViewProps) => {
  const {
    state: {isSmallScreen},
  } = useUiState();
  const app = useTaopix();
  const [viewMode, setViewMode] = useViewMode();

  useEffect(() => {
    if (props.layout.retroprints) {
      setViewMode(isSmallScreen ? ViewMode.List : ViewMode.Grid);
    }
  }, [isSmallScreen]);

  const content = useMemo(() => {
    if (!app.state.loaded) {
      return <></>;
    }
    switch (viewMode) {
      case ViewMode.Preview: {
        return <PrintPreviewView {...props} />;
      }
      case ViewMode.Grid: {
        if (props.layout.retroprints) {
          return (
            <RetroGridView
              {...props}
              min={props.layout.minimumprintsperproject}
              max={props.layout.maximumprintsperproject}
            />
          );
        }
        return <GridView {...props} />;
      }
      case ViewMode.List: {
        if (props.layout.retroprints) {
          return <RetroListView {...props} />;
        }
        return <ListView {...props} />;
      }
      case ViewMode.Single: {
        return <SingleView {...props} />;
      }
      case ViewMode.None: {
        return <></>;
      }
      default:
        return <></>;
    }
  }, [viewMode]);

  return content;
};

export default PageViewFactory;
